/**
 * Configuration for analytics providers.
 * Determines which providers receive specific events.
 */
const analyticsConfig = {
  // Default providers if an event-specific override is not found.
  // An array of provider names: e.g., ["mixpanel"], ["openpanel"], ["mixpanel", "openpanel"]
  defaultProviders: ["mixpanel"],

  // Specific overrides for event names.
  // Keys are event names (case-sensitive).
  // Values are arrays of provider names.
  // and are generally not configured here for standard event tracking.
  events: {
    clicked_checkout: ["mixpanel", "openpanel"],
    footer_cta: ["mixpanel", "openpanel"],
    MinOrderAlert: ["mixpanel", "openpanel"],
  },

  // Providers for user identification calls.
  userIdentificationProviders: ["mixpanel", "openpanel"],

  // Providers for page view tracking.
  // Note: Some providers might handle page views automatically.
  // This config controls explicit trackPageView calls.
  pageViewProviders: ["openpanel"],
};

module.exports = analyticsConfig;
